module.exports = __webpack_public_path__ + "img/split-file-complete-loading-icon1.e13a6e4d.svg";